











import { defineComponent, ref } from "@vue/composition-api";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import BaseSpinner from "@/components/BaseSpinner";
import InfiniteScroll from "@/components/InfiniteScroll";
import ModalView from "@/components/ModalView";
import UnlockedList from "../UnlockedList";

export default defineComponent({
  name: "UnlockedModalView",
  components: { InfiniteScroll, BaseSpinner, UnlockedList, ModalView },
  props: {
    show: { type: Boolean, required: true },
    ids: { type: Array as () => string[], required: true },
  },
  setup(props, { emit }) {
    const loading = ref<boolean>(false);
    const closeModal = () => {
      emit("close");
    };

    const { enableScroll, items, getNextPage, getFirstPage } = usePager(page =>
      providers.ContentPriceProvider.searchPurchases({
        data: {
          subjects: props.ids.map(id => ({ subjectId: id, subjectType: "message_attachment" })),
          page,
          size: 10,
          sort: "TIME,DESC",
        },
      })
    );

    const getData = () => {
      loading.value = true;
      getFirstPage().finally(() => (loading.value = false));
    };

    getData();

    return { closeModal, enableScroll, items, getNextPage, loading };
  },
});
